export default __webpack_public_path__ + "static/media/screen8.57a9ed85.png";